export var OneilMarketDirectionVersionStatus;
(function (OneilMarketDirectionVersionStatus) {
    OneilMarketDirectionVersionStatus["draft"] = "draft";
    OneilMarketDirectionVersionStatus["active"] = "active";
    OneilMarketDirectionVersionStatus["retired"] = "retired";
})(OneilMarketDirectionVersionStatus || (OneilMarketDirectionVersionStatus = {}));
export var OneilMarketDirectionState;
(function (OneilMarketDirectionState) {
    OneilMarketDirectionState["confirmedUptrend"] = "confirmedUptrend";
    OneilMarketDirectionState["uptrendUnderPressure"] = "uptrendUnderPressure";
    OneilMarketDirectionState["marketInCorrection"] = "marketInCorrection";
})(OneilMarketDirectionState || (OneilMarketDirectionState = {}));
export var OneilMarketIndexKey;
(function (OneilMarketIndexKey) {
    OneilMarketIndexKey["sp500"] = "sp500";
    OneilMarketIndexKey["nasdaqComposite"] = "nasdaqComposite";
    OneilMarketIndexKey["dow"] = "dow";
})(OneilMarketIndexKey || (OneilMarketIndexKey = {}));
//# sourceMappingURL=OneilMarketDirectionTypes.js.map